import React from "react";

export const CatholicMass = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            width={size}
            height={size}
            {...props}
        >
            <g fill="#ffe177">
                <path d="M204.83 188.573a7.496 7.496 0 00-9.799 4.059l-4.72 11.394a7.498 7.498 0 004.059 9.799c.938.389 1.91.573 2.867.573a7.502 7.502 0 006.932-4.632l4.72-11.394a7.5 7.5 0 00-4.059-9.799zM154.201 161.83l-8.72 8.721a7.498 7.498 0 005.304 12.802 7.478 7.478 0 005.304-2.197l8.72-8.721a7.5 7.5 0 00-10.608-10.605zM128.268 117.75l-11.394 4.72a7.5 7.5 0 00-4.059 9.799 7.5 7.5 0 009.799 4.059l11.394-4.72a7.5 7.5 0 004.059-9.799 7.5 7.5 0 00-9.799-4.059zM128.677 74.602c0-4.143-3.357-7.5-7.5-7.5h-12.333c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h12.333a7.5 7.5 0 007.5-7.5zM134.008 17.592l-11.394-4.719a7.5 7.5 0 10-5.74 13.86l11.394 4.719a7.47 7.47 0 002.867.572 7.505 7.505 0 006.933-4.632 7.503 7.503 0 00-4.06-9.8zM387.203 26.73a7.5 7.5 0 004.059-9.799 7.498 7.498 0 00-9.799-4.059l-11.394 4.72a7.5 7.5 0 00-4.059 9.799 7.5 7.5 0 009.799 4.059zM395.233 67.101h-12.332c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h12.332c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM309.047 192.631a7.5 7.5 0 00-13.858 5.74l4.72 11.394a7.5 7.5 0 1013.858-5.74z" />
            </g>
            <path
                d="M130.956 201.709c3.115-4.546 3.825-10.708.781-16.204l-11.685-21.091c-.784-1.416-2.82-1.416-3.604 0l-11.685 21.091c-3.045 5.495-2.334 11.658.781 16.204z"
                fill="#ffe177"
            />
            <path
                d="M131.737 185.505l-11.685-21.091c-.784-1.416-2.82-1.416-3.604 0l-3.489 6.298 8.196 14.793c3.045 5.495 2.334 11.657-.781 16.204h10.583c3.113-4.547 3.824-10.708.78-16.204z"
                fill="#ffd15b"
            />
            <path
                d="M150.318 254.598v-50.829a3.091 3.091 0 00-3.091-3.091H89.27a3.091 3.091 0 00-3.091 3.091v50.829z"
                fill="#fff3de"
            />
            <path
                d="M147.227 200.678h-21.03a3.091 3.091 0 013.091 3.091v50.829h21.03v-50.829a3.091 3.091 0 00-3.091-3.091z"
                fill="#ffe5c2"
            />
            <path
                d="M433.994 131.348h-84.262c-1.586 0-2.577 1.717-1.784 3.09l8.894 15.404c3.145 5.447 2.076 12.408-2.674 16.531-11.337 9.84-18.684 25.595-18.684 43.363 0 18.693 8.13 35.165 20.482 44.861h51.495c12.352-9.696 20.482-26.168 20.482-44.861 0-2.477-.157-4.909-.434-7.297l21.358-21.358a20.895 20.895 0 006.16-14.873v-13.826c0-11.598-9.435-21.034-21.033-21.034zm6.033 34.86a5.996 5.996 0 01-1.768 4.267l-15.176 15.176c-3.262-7.627-8.015-14.234-13.826-19.278-4.75-4.123-5.819-11.083-2.674-16.531l2.018-3.495h25.392a6.04 6.04 0 016.033 6.034v13.827z"
                fill="#ffe177"
            />
            <path
                d="M409.258 166.373c-4.75-4.123-5.819-11.083-2.674-16.531l10.678-18.495h-25.914l-10.678 18.495c-3.145 5.447-2.076 12.408 2.674 16.531 11.337 9.84 18.684 25.595 18.684 43.363 0 18.693-8.13 35.165-20.482 44.861h25.914c12.352-9.696 20.482-26.168 20.482-44.861 0-17.767-7.347-33.523-18.684-43.363z"
                fill="#ffd15b"
            />
            <g>
                <path
                    d="M177.351 98.187h56.34v117.335a5.15 5.15 0 005.151 5.151h26.394a5.15 5.15 0 005.151-5.151V98.187h56.34a5.15 5.15 0 005.151-5.151V66.642a5.15 5.15 0 00-5.151-5.151h-56.34V5.151A5.15 5.15 0 00265.236 0h-26.394a5.15 5.15 0 00-5.151 5.151v56.34h-56.34a5.15 5.15 0 00-5.151 5.151v26.394a5.15 5.15 0 005.151 5.151z"
                    fill="#f6a96c"
                />
            </g>
            <g>
                <path
                    d="M326.727 61.491H312.66v12.273a5.15 5.15 0 01-5.151 5.151h-46.038c-5.69 0-10.302 4.612-10.302 10.302V196.25a5.15 5.15 0 01-5.151 5.151h-12.327v14.122a5.15 5.15 0 005.151 5.151h26.394a5.15 5.15 0 005.151-5.151V98.187h56.34a5.15 5.15 0 005.151-5.151V66.642a5.15 5.15 0 00-5.151-5.151z"
                    fill="#ea9b58"
                />
            </g>
            <g>
                <path
                    d="M143.677 449.802v46.745c0 8.534 6.918 15.453 15.453 15.453h193.741c8.534 0 15.453-6.918 15.453-15.453v-46.745z"
                    fill="#e5e1e5"
                />
                <path
                    d="M336.354 449.802v46.745c0 8.534-6.918 15.453-15.453 15.453h31.969c8.534 0 15.453-6.919 15.453-15.453v-46.745zM209.642 449.802h92.716V512h-92.716z"
                    fill="#d7d0d6"
                />
                <path d="M271.453 449.802h30.905V512h-30.905z" fill="#c9bfc8" />
                <path
                    d="M121.988 409.062v21.927c0 10.937 8.866 19.803 19.803 19.803H370.21c10.937 0 19.803-8.866 19.803-19.803v-21.927z"
                    fill="#efedef"
                />
                <path
                    d="M357.988 409.062v21.927c0 10.937-8.866 19.803-19.803 19.803h32.024c10.937 0 19.802-8.866 19.802-19.803v-21.927z"
                    fill="#e5e1e5"
                />
                <path
                    d="M74.816 285.771v79.967c0 24.474 19.84 44.314 44.314 44.314h273.741c24.474 0 44.314-19.84 44.314-44.314v-79.967z"
                    fill="#e5e1e5"
                />
                <path
                    d="M394.044 285.771v79.967c0 24.474-19.84 44.314-44.314 44.314h43.14c24.474 0 44.314-19.84 44.314-44.314v-79.967z"
                    fill="#d7d0d6"
                />
                <path
                    d="M448.325 254.598H63.675c-5.69 0-10.302 4.612-10.302 10.302v11.559c0 5.69 4.612 10.302 10.302 10.302h384.649c5.69 0 10.302-4.612 10.302-10.302V264.9c0-5.69-4.612-10.302-10.301-10.302z"
                    fill="#c9bfc8"
                />
                <path
                    d="M448.325 254.598h-61.1c5.69 0 10.302 4.612 10.302 10.302v11.559c0 5.69-4.612 10.302-10.302 10.302h61.1c5.69 0 10.302-4.612 10.302-10.302V264.9c-.001-5.69-4.613-10.302-10.302-10.302z"
                    fill="#baafb9"
                />
                <g>
                    <path
                        d="M323.992 316.677h-49.964a5.15 5.15 0 00-5.151 5.151v52.168a5.15 5.15 0 005.151 5.151h49.964a5.15 5.15 0 005.151-5.151v-52.168a5.15 5.15 0 00-5.151-5.151z"
                        fill="#c9bfc8"
                    />
                    <path
                        d="M323.992 316.677h-21.634a5.15 5.15 0 015.151 5.151v52.168a5.15 5.15 0 01-5.151 5.151h21.634a5.15 5.15 0 005.151-5.151v-52.168a5.15 5.15 0 00-5.151-5.151z"
                        fill="#baafb9"
                    />
                    <path
                        d="M188.008 379.146h49.964a5.15 5.15 0 005.151-5.151v-52.168a5.15 5.15 0 00-5.151-5.151h-49.964a5.15 5.15 0 00-5.151 5.151v52.168a5.15 5.15 0 005.151 5.151z"
                        fill="#c9bfc8"
                    />
                    <path
                        d="M237.972 316.677h-21.634a5.15 5.15 0 015.151 5.151v52.168a5.15 5.15 0 01-5.151 5.151h21.634a5.15 5.15 0 005.151-5.151v-52.168a5.15 5.15 0 00-5.151-5.151z"
                        fill="#baafb9"
                    />
                    <path
                        d="M151.952 316.677h-41.08a5.15 5.15 0 00-5.151 5.151v43.91c0 7.405 6.003 13.408 13.408 13.408h32.822a5.15 5.15 0 005.151-5.151v-52.168a5.15 5.15 0 00-5.15-5.15z"
                        fill="#c9bfc8"
                    />
                    <path
                        d="M151.952 316.677h-21.634a5.15 5.15 0 015.151 5.151v52.168a5.15 5.15 0 01-5.151 5.151h21.634a5.15 5.15 0 005.151-5.151v-52.168a5.151 5.151 0 00-5.151-5.151z"
                        fill="#baafb9"
                    />
                    <path
                        d="M354.897 321.828v52.168a5.15 5.15 0 005.151 5.151h32.822c7.405 0 13.408-6.003 13.408-13.408v-43.91a5.15 5.15 0 00-5.151-5.151h-41.08a5.15 5.15 0 00-5.15 5.15z"
                        fill="#c9bfc8"
                    />
                    <path
                        d="M401.128 316.677h-21.634a5.15 5.15 0 015.151 5.151v43.91c0 7.405-6.003 13.408-13.408 13.408h21.634c7.405 0 13.408-6.003 13.408-13.408v-43.91a5.15 5.15 0 00-5.151-5.151z"
                        fill="#baafb9"
                    />
                </g>
            </g>
        </svg>
    );
}